export const play = () => {
    return {
        type: 'PLAY'
    }
}

export const stop = () => {
    return {
        type: 'STOP'
    }
}


// WEBPACK FOOTER //
// ./src/actions/player.js